import en from "./en";
let strings = {
    en,
};
export default strings;
